import React from 'react'

const Layout = ({ id, horizontal, highlight, children, fade, className, style }) => {
  return <div className={`Layout ${horizontal && 'horizontal'} ${highlight && 'highlight'} ${fade && 'fadeIn'} ${className}`} style={style} id={id}>
    {children}
  </div>
}

export default Layout
